module.exports = __webpack_public_path__ + "img/axis-realty-group-banner-6.0f9b4378.jpg";